import { OfferFragment } from '@occc/graphql';
import { ScheduleFormValues } from './types';
import { parseDate } from '../../lib/date';

export const transformOfferToScheduleValues = (
  offer: OfferFragment,
): Partial<ScheduleFormValues> => {
  const marketingContent = offer.marketingContents[0];

  const publishAt = offer.publishAt ? parseDate(offer.publishAt) : undefined;
  const expireAt = offer.expireAt ? parseDate(offer.expireAt) : undefined;

  return {
    publishAtDate: publishAt || null,
    publishAtTime: publishAt || null,
    expireAtDate: expireAt || null,
    expireAtTime: expireAt || null,
    marketingContent: marketingContent?.id
      ? {
          id: marketingContent.id,
          triggeredMessageContent: {
            fulfillmentSms: marketingContent?.triggeredMessageContent?.fulfillmentSms,
            visibilitySms: marketingContent?.triggeredMessageContent?.visibilitySms,
            progressSms: marketingContent?.triggeredMessageContent?.progressSms,
          },
        }
      : {},
    triggerPreferences: {
      triggerOnFulfillment: offer.triggerPreferences.triggerOnFulfillment,
      triggerOnVisibility: offer.triggerPreferences.triggerOnVisibility,
      triggerOnProgress: offer.triggerPreferences.triggerOnProgress,
    },
  };
};
